import React from "react";
import { OTPContent } from "src/content";

const OTP = () => {
  return (
    <div>
      <OTPContent />
    </div>
  );
};

export default OTP;
